// extracted by mini-css-extract-plugin
module.exports = {"partnerListItemWrapper":"_3S_Wi","partnerListItem":"_1DPyH","partnerListItemDescription":"_2uewa","descriptionTextWrapper":"_31Y-u","partnerMaskWrapper":"_34q4A"};